/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontContactButton_seller = {
    readonly serviceId: string | null;
    readonly " $refType": "StorefrontContactButton_seller";
};
export type StorefrontContactButton_seller$data = StorefrontContactButton_seller;
export type StorefrontContactButton_seller$key = {
    readonly " $data"?: StorefrontContactButton_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontContactButton_seller">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontContactButton_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
(node as any).hash = 'e40e078ed7e25c3329a991d14ec00f41';
export default node;
